import React, {useState, useEffect} from 'react';
import {Link, useHistory} from 'react-router-dom';
import {useSelector, useDispatch} from 'react-redux';
import ErrorMessage from "./error/ErrorMessage";
import { classAddedMobile, scrollMobileSelector } from '../../../../store/reducers/scrollMobileReducer';
import {servicesSelector} from '../../../../store/reducers/selServReducer';
import {primaryContractSelector} from '../../../../store/reducers/primConReducer';
import {secondContractSelector} from '../../../../store/reducers/secConReducer';
import {promoCodeSelector} from '../../../../store/reducers/promoCodeReducer';
import {transformStateToAgiloft} from "../../../../store/transformers/agiloftTransformer";
import api from "../../../../constants/api";
import {selectCompanyInfo} from "../../../../store/reducers/companyInfoReducer";
import LoadingSpinner from "../../../common/LoadingSpinner";
import { skipSecConSelector } from '../../../../store/reducers/skipSecContReducer';
import {recaptchaSiteKey} from "../../../../constants";
import { registrationSettingsSelector } from '../../../../store/reducers/registrationSettingsReducer'; 

function Summary() {
    const dispatch = useDispatch();
    const history = useHistory();
    const skipSecCon = useSelector(skipSecConSelector);
    const serviceArr = useSelector(servicesSelector);
    const promoCode = useSelector(promoCodeSelector);
    const scroll = useSelector(scrollMobileSelector);
    const [scrollClass, setScrollClass] = useState(scroll);
    const registrationData = useSelector(registrationSettingsSelector);
    const companyInformation = useSelector(selectCompanyInfo);
    const primaryContract = useSelector(primaryContractSelector);
    const secondaryContract = useSelector(secondContractSelector);
    const [promoCodeIs, setPromoCodeIs] = useState(false);
    const [selected, setSelected] = useState(false);
    const [showError, setShowError] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [errors, setErrors] = useState([]);
    const [showErrorMissing, setShowErrorMissing] = useState(false);
    const [previousPath, setPreviousPath] = useState("/form/secondary")

    useEffect(() => {
        window.scrollTo(0, 0);
        setTimeout(function(){ setScrollClass("progression_container small") ; }, 10);

        if(promoCode.isHuri === true) {
            setPromoCodeIs(true);
        }
        if(promoCode.code !== "") {
            setPreviousPath("/form/nomination");
        }
    }, []); // eslint-disable-line

    async function onSubmit(e) {
        e.preventDefault();
        
        if(selected === false) {
            setShowError(true);
            return;
        } else if(promoCode.isHuri === true) {
            if((promoCode.code === "") || (serviceArr.length === 0) || (primaryContract.length === 0)) {
                setShowErrorMissing(true);
                return;
            } else {
                setIsLoading(true);
                setErrors([]);

                const token = await window.grecaptcha.execute(recaptchaSiteKey, {action: 'submit'})
                const data = transformStateToAgiloft(companyInformation, primaryContract, secondaryContract, serviceArr, promoCode, token);
                const response = await api.submitAgiloftData(data);

                setIsLoading(false);
                const errors = response.errors?.map(error => error.message) || [];
                setErrors(errors);

                if (errors.length === 0) {
                    history.push('/success');
                }
            }
        } else {   
            if((companyInformation.name === "") || (serviceArr.length === 0) || (primaryContract.length === 0) || (secondaryContract.length === 0)) {
                setShowErrorMissing(true);
                return;
            } else {     
                setIsLoading(true);
                setErrors([]);

                const token = await window.grecaptcha.execute(recaptchaSiteKey, {action: 'submit'})
                const data = transformStateToAgiloft(companyInformation, primaryContract, secondaryContract, serviceArr, promoCode, token);
                const response = await api.submitAgiloftData(data);

                setIsLoading(false);
                const errors = response.errors?.map(error => error.message) || [];
                setErrors(errors);

                if (errors.length === 0) {
                    history.push('/success');
                }
            }
        }
    }

    function toggleError() {
        setShowError(false);
    };

    function setClass() {
        dispatch(classAddedMobile("progression_container small startTop"));
    };

    return (
        <div className={scrollClass}>
            <h2>Summary</h2>
            <p className="summary-p">{registrationData.summary_description}</p>
            <form className="summary-form" onSubmit={onSubmit}>
                <div className="list-divider"></div>
                <div className="flex_container_column">
                    <div>
                        <label><b>Service:</b></label>
                        <Link to="/form/?summary=true" onClick={setClass}>
                            <div className="edit">See service</div>
                        </Link>
                    </div>
                    <div className="services">
                        <div className="service">{serviceArr}</div>
                    </div>
                </div>
                <div className="list-divider"></div>
                <div className="flex_container">
                    <div>
                        <div>
                            <label><b>Primary contract administrator:</b></label>
                        </div>
                        <div>
                            <Link to="/form/primary/?summary=true" onClick={setClass}>
                                <div className="edit">Edit information</div>
                            </Link>
                        </div>
                    </div>
                    <div>
                        <p>{primaryContract.firstName}</p>
                        <p>{primaryContract.lastName}</p>
                        <p>{primaryContract.mobileNum}</p>
                        <p>{primaryContract.email}</p>
                    </div>
                </div>
                <div className="list-divider"></div>
                <div className="flex_container">
                    <div>
                        <div>
                            <label><b>Secondary contract administrator:</b></label>
                        </div>
                        <div>
                            <Link to="/form/secondary/?summary=true" onClick={setClass}>
                                <div className="edit">Edit information</div>
                            </Link>
                        </div>
                    </div>

                    <div>                     
                    {skipSecCon.isSkipped === true 
                        ? <>
                            <p className="dimmedSmall">This step has been skipped</p>
                            <p className="dimmedSmall">Click on edit if you want to add information</p>
                        </>
                        : <>
                            <p>{secondaryContract.firstName}</p>
                            <p>{secondaryContract.lastName}</p>
                            <p>{secondaryContract.mobileNum}</p>
                            <p>{secondaryContract.email}</p>
                        </>
                    }
                    </div>
                </div>

                {promoCodeIs &&
                    <>
                        <div className="list-divider"></div>
                        <div className="flex_container">
                            <div>
                                <div>
                                    <label><b>Nomination code:</b></label>
                                </div>
                                <div>
                                    <Link to="/form/nomination/?summary=true" onClick={setClass}>
                                        <div className="edit">Edit information</div>
                                    </Link>
                                </div>
                            </div>
                            <div>
                                <p>{promoCode.code}</p>
                            </div>
                        </div>
                    </>
                }

                <div onClick={toggleError}>
                    <div className="accept-contact" onClick={() => {setSelected(!selected)}}>
                        <div className="toggleContainer">
                            <div className="toggleGroup">
                                <div className={`toggle-container ${!selected ? "" : "disabledBackground"}`}>
                                    <div className={`dialog-button ${selected ? "" : "disabled"}`}></div>
                                </div>
                            </div>

                        </div>
                        <div className="accept-label">
                                <p>{registrationData.summary_accept}</p>
                            </div>

                        {showError && <ErrorMessage>Click slider to accept</ErrorMessage>}
                    </div>
                    <div>
                        <p className="terms-link"><a target="_blank" href="/terms-of-service">{registrationData.summary_terms}</a></p>
                    </div>

                    {errors.length > 0 && (
                        <div className="errors">
                            <div>
                                {errors.map(error => <p>{error}</p>)}
                            </div>
                        </div>
                    )}
                </div>

                <div className="button_container">
                    <Link to={previousPath} onClick={setClass} className="previous"><span>
                        <svg width="13" height="11" viewBox="0 0 13 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M10.0815 6.5201L8.27352 8.3281L7.52152 9.0961C6.92952 9.6881 6.30552 10.3121 5.64952 11.0001H7.77752C8.92952 9.8001 11.3615 7.1441 12.7215 5.7841C11.3775 4.4401 8.94552 1.8001 7.77752 0.600098H5.64952C6.30552 1.2881 6.92952 1.9121 7.52152 2.5041L8.27352 3.2721L8.99352 4.0081C9.45752 4.4561 9.84152 4.8721 10.0815 5.0801H0.561523V6.5201H10.0815Z"
                                fill="white"></path>
                        </svg>
                    </span> Previous</Link>
                    {showErrorMissing === true && <p className="missing-fields_error small">Some fields are missing, please fill them in to send application</p>}

                    <button className="nextSubmit submit" type="submit" disabled={isLoading}>
                        {isLoading ? <LoadingSpinner small={true} light={true}/> : (
                            <>
                                <span>Send application</span>
                                <svg width="13" height="11" viewBox="0 0 13 11" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M10.0815 6.5201L8.27352 8.3281L7.52152 9.0961C6.92952 9.6881 6.30552 10.3121 5.64952 11.0001H7.77752C8.92952 9.8001 11.3615 7.1441 12.7215 5.7841C11.3775 4.4401 8.94552 1.8001 7.77752 0.600098H5.64952C6.30552 1.2881 6.92952 1.9121 7.52152 2.5041L8.27352 3.2721L8.99352 4.0081C9.45752 4.4561 9.84152 4.8721 10.0815 5.0801H0.561523V6.5201H10.0815Z"
                                        fill="white"/>
                                </svg>
                            </>
                        )}
                    </button>
                </div>
            </form>
        </div>
    );
}

export default Summary;
